import React from 'react';
import './index.scss';
import { useParams } from 'react-router-dom';
import OrdersReport from './OrdersReport';
import StudentsReport from './StudentsReport';
import InstructorsReport from './InstructorsReport';
import LearnersReport from './LearnersReport';
import CoursesReport from './CoursesReport';
import QuestionReport from './QuestionReport';

interface Props {
    location: any;
}

export default function Reports(props: Props) {
    const RouteParams: any = useParams();
    if (RouteParams['type'] === 'students')
        return <StudentsReport location={props.location}/>;
    if (RouteParams['type'] === 'instructors')
        return <InstructorsReport location={props.location}/>;
    if (RouteParams['type'] === 'learners')
        return <LearnersReport location={props.location}/>;
    if (RouteParams['type'] === 'courses')
        return <CoursesReport location={props.location}/>;
    if (RouteParams['type'] === 'questions')
        return <QuestionReport location={props.location}/>;
    return <OrdersReport location={props.location}/>;
}
